import Helper from '@ember/component/helper';
import { inject as service } from '@ember/service';
import AuthService from 'cio/services/auth';
import { Permission } from '@customerio/hydra-permissions';

export default class HasPermissionHelper extends Helper {
  @service auth!: AuthService;

  compute([permission]: [Permission]) {
    return this.auth.hasPermission(permission);
  }
}
